import type { SaleItemSummary } from '@src/features/orders/form-inputs/core/resolveSaleItemSummary';

/** What names a group on screen, in the accordion and in the modal header. */
export const resolveSaleGroupTitle = (summary: SaleItemSummary | null): string => summary?.productName ?? '';
